import React from "react";

export default function TableHeader({ children, textAlign = 'center' }) {
  return (
    <th scope="col" className={`px-6 py-3 text-${textAlign} text-xs font-medium text-gray-500 uppercase tracking-wider`}>
      {children}
    </th>
  );
}
